/**
 * @fileOverview This file contains the implementation of the ClientFilter component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { Autocomplete, Checkbox, TextField } from '@mui/material';
import customAxios from '../../utils/customAxios';
import { useEffect, useState } from 'react';
import { GlobalVariables } from '../../globalVar';
import { GridToolbar, GridToolbarContainer } from '@mui/x-data-grid-pro';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { getToast } from '../../utils/toastConfig';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
//#endregion

const ClientFilter = ({
  selectedClients,
  setSelectedClients,
  csvOptions,
  printOptions,
  ...rest
}) => {
  const [clients, setClients] = useState([]);
  const { clientFilterStr } = useTranslationHook();

  const fetchClientsFiltered = async () => {
    try {
      const endpoint = `${GlobalVariables.getURL()}listClients/`;
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });

      if (response.status === 204) {
        setClients([]);
        return;
      }
      setClients(response.data);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    }
  };

  useEffect(() => {
    // fetchClients();
    fetchClientsFiltered();
  }, []);

  const handleClientChange = (event, newValue, reason) => {
    if (reason === 'clear' || newValue.length === 0) {
      setSelectedClients('all');
    } else {
      setSelectedClients(newValue.map((client) => client.id));
    }
  };

  const filteredClients = clients.filter((client) =>
    selectedClients.includes(client.id),
  );

  return (
    <GridToolbarContainer
      sx={{ display: 'flex', justifyContent: 'space-between', mb: '1rem' }}
    >
      <GridToolbar csvOptions={csvOptions} printOptions={printOptions} />
      <Autocomplete
        sx={{ width: '50%' }}
        multiple
        disableCloseOnSelect
        limitTags={2}
        ListboxProps={{
          style: { maxHeight: '15rem' },
          position: 'bottom-start',
        }}
        options={clients}
        onChange={handleClientChange}
        value={filteredClients}
        getOptionLabel={(client) => client.business_name}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.business_name}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={clientFilterStr}
            variant="standard"
          />
        )}
      />
    </GridToolbarContainer>
  );
};

export default ClientFilter;
